<template>
	<TableView :col="columns" :getData="getData"/>           
</template>
<script>
import common from '@/assets/js/common.js';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['report_date'],
  data(){
  	return {
      columns: (() => {
        const cols = [
          { title: 'Contract Note', field: 'contract_note', thComp: 'FilterTh', tdStyle: {'text-decoration':'underline dashed'},sortable: true, tdOnClick:this.ShowDealDetail},
          { title: 'Ticket Number', field: 'ticket_number', thComp: 'FilterTh' },
          { title: 'Acc. No.', field: 'account_number', thComp: 'FilterTh', tdStyle: {padding: this.can_access('deal','modify')?"":"0.8rem !important"}},
          { title: 'Currency', field: 'currency', thComp: 'FilterTh'},
          { title: 'Trade Date', field: 'trade_date', sortable: true },
          { title: 'Settlement Date', field: 'settlement_date', sortable: true },
          { title: 'Side', field: 'type', thComp: 'FilterTh', sortable: true, tdStyle: (row) => {if(row.type_total_quantity == 1 || row.type == 'FX') return {color: "green"};else /* if(["SELL","WITHDRAWAL","TRANSFER OUT","FOP OUT"].indexOf(row.type)>=0) */ return {color: 'red'};}},
          { title: 'Issuer Name', field: 'stock', nested: 'issuer_name', thComp: 'FilterTh'},
          /*{ title: 'Security ID (ISIN)', field: 'stock', nested: 'isin'},*/
          { title: 'Ticker', field: 'stock', nested: 'tidm', thComp: 'FilterTh'},
          { title: 'Quantity', field: 'total_quantity', thComp: 'FilterTh', tdComp: 'Number', 'floatLength': 2},
          { title: 'Trade Price', field: 'trade_price', sortable: true , tdComp: 'Number'},
          { title: 'Trade Value', field: 'trade_value', sortable: true, tdComp: 'Number'},
          { title: 'Cost Price', field: 'cost_price', tdComp: 'Number' },
          { title: 'Total Charges', field: 'total_other_charges', tdComp: 'Number' },
          { title: 'Cosideration', field: 'total_consideration', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Notes', field: 'notes', thComp: 'FilterTh'},
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('report', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  created() {
  },
  methods: {
    async getData(query, filter) {
      var { limit = 100, offset = 0, sort = 'trade_date', order = '' } = JSON.parse(JSON.stringify(query));
      if(!sort) sort = 'trade_date';
      //filter['has_trade'] = 1;
      filter['approved_at'] = {from_date:'2000-01-01'};
      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });
      filter['trade_date'] = {from_date: this.report_date[0], to_date: this.report_date[1]};
      let uri = 'trade_list?with_cancelled=1&limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      this.$emit('setFilter', filter);
      return await this.call_axios(uri);
    }
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>